<template>
    <h3><br/>The Pacific Health Wayfinders Programme</h3>
    <div class="notmulticol">
        <img src="LiilandJerome.jpg" width="600" style="float:right;margin:0 0 1em 1em;width:clamp(120px, 600px, 40vw)" alt=""/>
<p>The <em>Pacific Health Wayfinders </em>is a Pacific health student recruitment initiative by the Faculty of Medical and Health Sciences Office of the Associate Dean for Pacific led by Associate Professor Collin Tukuitonga.</p>

<p>The Pacific Health Student Recruitment Team leads this initiative which aims to attract more Pacific students to pursue a career in health by studying with the Faculty of Medical and Health Sciences after secondary school. The <em>Pacific Health Wayfinders</em> programme is for students of indigenous Pacific ancestry who are either a New Zealand citizen or permanent resident.</p>

<p>The <em>Pacific Health Wayfinders</em> programme focuses on essential elements such as subject selection, pathway planning and course counselling.</p>
<p>To join the programme, please ensure you meet the eligibility criteria (above) and fill in the eligibility form.</p>
</div>
    <br/>
    <button @click.prevent="$parent.nextTab">Apply now</button>
</template>

<script>
export default {
    name:"About",
    methods:{
        checkAllGood: function (){
            // this is just an intro, always all good :)
            return true;
        }
    }
}
</script>

<style>
.notmulticol>p {
    margin: 0.5em 0;
}
</style>
